export default "__VITE_ASSET__3udQnSTn__"